module.exports = __webpack_public_path__ + "img/in-service.9c9b54eb.svg";